import React, { useState, useEffect, useRef } from 'react';
import styles from './CommonMbtableCard.module.css';
import product_icon from '../../images/icons/MbDashboardIcons/product_icon.svg';
import subproduct_icon from '../../images/icons/MbDashboardIcons/subproduct_icon.svg';
import loanamount_icon from '../../images/icons/MbDashboardIcons/loanamount_icon.svg';
import payout_icon from '../../images/icons/MbDashboardIcons/payout_icon.svg';
import docPending_icon from '../../images/icons/MbDashboardIcons/docPending_icon.svg';
import funding_icon from '../../images/icons/MbDashboardIcons/funding_icon.svg';
import bank_icon from '../../images/icons/MbDashboardIcons/bank_icon.svg';
import arrow_icon from '../../images/icons/MbDashboardIcons/arrow_icon.svg';
import { numberFormat, DateFormat } from '../Table/RMColumnData';
import moment from 'moment';
import classnames from 'classnames';

function leadColor(eachlead, statusbox) {
  if (eachlead.status == 'New Lead' || eachlead.status == 'closed') {
    statusbox.current.style.backgroundColor = '#a1f5a8';
    statusbox.current.style.color = '#00ACB8';
  } else if (eachlead.status == 'Doc Pending') {
    statusbox.current.style.backgroundColor = '#ffdec1';
    statusbox.current.style.color = '#FF8000';
  } else if (eachlead.status == 'Login') {
    statusbox.current.style.backgroundColor = '#fff1e5';
    statusbox.current.style.color = '#FF8000';
  } else if (eachlead.status == 'Follow Up') {
    statusbox.current.style.backgroundColor = '#aebae4';
    statusbox.current.style.color = '#1165A3';
  } else if (eachlead.status == 'Not Interested') {
    statusbox.current.style.backgroundColor = '#ffdec1';
    statusbox.current.style.color = '#f56565';
  } else if (eachlead.status == 'BP Raised') {
    statusbox.current.style.backgroundColor = '#aebae4';
    statusbox.current.style.color = '#1165A3';
  }
}
//test
export const Diff_DateFormatIn_SMHD = date => {
  if (date && moment(date).isValid()) {
    let diffSecond = moment().diff(moment(date), 'seconds');
    if (diffSecond < 60) {
      return diffSecond + 's';
    } else if (diffSecond >= 60 && diffSecond < 60 * 60) {
      return Math.round(diffSecond / 60) + 'm';
    } else if (diffSecond >= 60 * 60 && diffSecond < 60 * 60 * 24) {
      return Math.round(diffSecond / (60 * 60)) + 'h';
    } else {
      return Math.round(diffSecond / (60 * 60 * 24)) + 'd';
    }
  }
};
//test end

//moment().startOf('day').fromNow();
// export const DateFormatInDays = date => {
//   if (date && moment(date).isValid()) {
//     return moment().diff(moment(date), 'days') + 'd';
//   }
// };
export const nameformat = name => {
  let firstName = '',
    middleName = '',
    lastName = '',
    fullname = '';
  if (name.firstName) {
    firstName = name.firstName;
  }
  if (name.middleName) {
    middleName = name.middleName;
  }
  if (name.lastName) {
    lastName = name.lastName;
  }
  fullname = firstName + ' ' + middleName + ' ' + lastName;

  if (fullname.length > 25) {
    return fullname.slice(0, 25) + '...';
  }
  return fullname;
};
function CommonMbTableCard({ each }) {
  const {
    status,
    leadID,
    accordian,
    body,
    toggleArrow,
    box,
    box2,
    box3,
    box4,
    sourcingDate,
    high,
    medium,
    low
  } = styles;

  const [active, setActive] = useState(false);
  const statusbox = useRef(null);

  function toggle() {
    setActive(!active);
  }
  useEffect(() => {
    leadColor(each, statusbox);
  }, [each.status]);

  const classnameForPriority = classnames({
    [`${high}`]: each.priority === 'High',
    [`${medium}`]: each.priority === 'Medium',
    [`${low}`]: each.priority === 'Low'
  });

  return (
    <div className={`${accordian} ${classnameForPriority} relative`}>
      <div className={` text-black-500 font-roboto`}>
        <div className={`${box}`}>
          <div className={` font-normal  font-roboto text-black-700`}>
            {nameformat(each.name)}
          </div>
          <div className={`${status}`} ref={statusbox}>
            {each?.status == 'New Lead' ? 'Lead' : each.status}
          </div>
        </div>
        <div className={`${box4}`}>
          <div className={`${leadID}`}>{each?.leadId}</div>
          <div className={`${sourcingDate}`}>
            {Diff_DateFormatIn_SMHD(each?.sourcingDate || '')}
          </div>
        </div>

        <div className={`${box2}`}>
          <div className={`flex items-center mt-3`}>
            <img src={product_icon} alt="" />
            <span className="px-3 ">
              {each?.product || <span>&#8212; </span>}
            </span>
          </div>
          <div className={`flex items-center mt-3`}>
            <img src={subproduct_icon} alt="" />
            <span className="px-3">
              {each?.subProduct || <span>&#8212; </span>}
            </span>
          </div>
          <div className={`flex items-center mt-3`}>
            <img src={loanamount_icon} alt="" />
            <span className="px-3">
              &#8377;{numberFormat(each?.loanAmount || 0)}
            </span>
          </div>
          <div className={`flex items-center mt-3 text-red-300`}>
            <img src={docPending_icon} alt="" />
            <div className="pl-3">{each?.doc_pending || 0}</div>
          </div>
        </div>
      </div>
      <div
        className={`${body} font-normal text-sm  font-roboto text-black-500`}
        style={{
          overflow: 'hidden',
          maxHeight: active ? '150px' : '0px'
        }}
      >
        <div className={`${box3} text-sm `}>
          <div className={`flex items-center mt-3`}>
            <img src={payout_icon} alt="" />
            <div className="pl-3">
              &#8377; &nbsp;{numberFormat(each?.payout || 0)}
            </div>
          </div>
          <div className={` flex items-center mt-3`}>
            <img src={funding_icon} alt="" />
            <div className="pl-3">
              &#8377; &nbsp;{numberFormat(each?.disbursedAmount || 0)}
            </div>
          </div>
          <div className={`flex items-center mt-3`}>
            <img src={bank_icon} alt="" />
            <div className="pl-3">
              {each?.bankName || <span>&#8212; </span>}
            </div>
          </div>
        </div>
        <div className="mt-3 text-sm text-black-50">
          <span>City:</span>
          <span>{each?.city || <span>&#8212; </span>}</span>
        </div>
        <div className="text-sm text-black-50">
          <span>Last action: </span>
          <span> {DateFormat(each?.lastActionDate || '')}</span>
        </div>
      </div>
      <div className={`${toggleArrow} cursor-pointer`} onClick={toggle}>
        <img
          src={arrow_icon}
          alt=""
          className={active ? 'transform rotate-0' : 'transform rotate-180'}
        />
      </div>
    </div>
  );
}

export default CommonMbTableCard;
